import React from "react";
import {
  CalendarCheck2,
  CalendarPlus,
  ChevronRight,
  Clock3,
} from "lucide-react";
import { formatCompanionWorkoutDateTime } from "@/components/daily/companionWorkoutCalendar";

const CompanionWorkoutCalendarAction = ({
  workout,
  added = false,
  adding = false,
  onAdd,
  onOpenCalendar,
}) => {
  if (!workout) return null;
  const segments = workout.segments || {};

  return (
    <div
      data-testid="companion-workout-calendar-action"
      className="mt-2 w-full max-w-[92%] rounded-[22px] p-4 forr-panel-action"
      style={{ border: "1px solid var(--forr-action-border)" }}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.18em] forr-text-teal-deep">
            Companion-built workout
          </div>
          <h3 className="mt-2 font-display text-xl forr-text-ink">{workout.title}</h3>
          <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs forr-text-mute">
            <span className="inline-flex items-center gap-1.5">
              <Clock3 size={13} /> {formatCompanionWorkoutDateTime(workout)}
            </span>
            <span>{workout.durationMinutes} min</span>
          </div>
        </div>
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white/75">
          {added ? (
            <CalendarCheck2 size={19} className="forr-text-teal-deep" />
          ) : (
            <CalendarPlus size={19} className="forr-text-teal-deep" />
          )}
        </div>
      </div>

      <div className="mt-4 grid gap-2 sm:grid-cols-3">
        {segments.preparation?.length > 0 && (
          <div className="rounded-2xl bg-white/65 p-3">
            <div className="text-[9px] uppercase tracking-[0.15em] forr-text-mute">
              Prepare
            </div>
            <p className="mt-1.5 line-clamp-3 text-xs leading-relaxed forr-text-soft">
              {segments.preparation[0]}
            </p>
          </div>
        )}
        <div className="rounded-2xl bg-white/65 p-3">
          <div className="text-[9px] uppercase tracking-[0.15em] forr-text-mute">
            Main output
          </div>
          <p className="mt-1.5 line-clamp-3 text-xs leading-relaxed forr-text-soft">
            {segments.main}
          </p>
        </div>
        <div className="rounded-2xl bg-white/65 p-3">
          <div className="text-[9px] uppercase tracking-[0.15em] forr-text-mute">
            Cooldown
          </div>
          <p className="mt-1.5 line-clamp-3 text-xs leading-relaxed forr-text-soft">
            {segments.cooldown}
          </p>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        {!added ? (
          <button
            type="button"
            onClick={onAdd}
            disabled={adding}
            className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium forr-btn-primary disabled:opacity-50"
          >
            <CalendarPlus size={16} />
            {adding ? "Adding…" : "Add workout to calendar"}
          </button>
        ) : (
          <div className="inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium forr-text-teal-deep forr-surface-tint">
            <CalendarCheck2 size={16} /> Added to APOS calendar
          </div>
        )}
        {added && onOpenCalendar && (
          <button
            type="button"
            onClick={onOpenCalendar}
            className="inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm forr-btn-secondary"
          >
            Open calendar <ChevronRight size={15} />
          </button>
        )}
      </div>
    </div>
  );
};

export default CompanionWorkoutCalendarAction;
